<template>
  <div class="add-menu-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/sys/menu">菜单管理</el-breadcrumb-item>
          <el-breadcrumb-item to="/sys/menu/addMenu">{{ title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="系统" prop="companyId">
          <el-select v-model="ruleForm.companyId" placeholder="请选择系统" clearable style="width: 100%;">
            <el-option
              v-for="item in companyOptions"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="icon" prop="icon">
          <el-input v-model="ruleForm.icon" clearable placeholder="请输入图标名称"></el-input>
        </el-form-item>
        <el-form-item label="上级菜单" prop="menuParentName">
            <el-input v-model="ruleForm.menuParentName" clearable placeholder="请选择上级菜单" @focus="selectMenuItem"></el-input>
        </el-form-item>
        <el-form-item label="菜单类型" prop="menuLevel">
          <el-select v-model="ruleForm.menuLevel" placeholder="请选择菜单类型" style="width:100%">
            <el-option key="M" label="目录" value="M"></el-option>
            <el-option key="C" label="菜单" value="C"></el-option>
            <el-option key="F" label="按钮" value="F"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="菜单名称" prop="menuName">
            <el-input v-model="ruleForm.menuName" placeholder="请输入菜单名称"></el-input>
        </el-form-item>
        <el-form-item label="权限标识" prop="menuPermissions" v-if="ruleForm.menuLevel == 'F'">
            <el-input v-model="ruleForm.menuPermissions" placeholder="请输入权限标识"></el-input>
        </el-form-item>
        <el-form-item label="组件路径">
            <el-input v-model="ruleForm.component" placeholder="请输入组件路径"></el-input>
        </el-form-item>
        <el-form-item label="menuUrl">
            <el-input v-model="ruleForm.menuUrl" placeholder="请输入菜单URL"></el-input>
        </el-form-item>
        <el-form-item label="路由名称">
            <el-input v-model="ruleForm.name" placeholder="请输入路由名称"></el-input>
        </el-form-item>
        <el-form-item label="显示顺序" prop="sortNo">
            <el-input v-model="ruleForm.sortNo" placeholder="请输入显示顺序"></el-input>
        </el-form-item>
        <el-form-item label="缓存状态" prop="alive" v-if="ruleForm.menuLevel !== 'F'">
            <el-radio-group v-model="ruleForm.keepAlive">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="是否显示">
            <el-radio-group v-model="ruleForm.hidden">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单状态" prop="menuShow">
            <el-radio-group v-model="ruleForm.menuShow">
                <el-radio :label="true">显示</el-radio>
                <el-radio :label="false">隐藏</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="菜单描述" prop="menuDesc">
            <el-input v-model="ruleForm.menuDesc" placeholder="请输入菜单描述"></el-input>
        </el-form-item>
        <div class="footer-btn">
          <el-button type="danger" size="small" icon="el-icon-close" @click="$router.back()">取 消</el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="changeOrAddMenu('ruleForm')">确 定</el-button>
        </div>
      </el-form>
    </el-card>
    <!-- 选择上级部门 dialog -->
    <el-dialog
      width="30%"
      top="5vh"
      append-to-body
      title="菜单选择"
      :visible.sync="innerVisible"
    >
      <el-tree
        :data="tableData"
        show-checkbox
        node-key="menuId"
        ref="tree"
        highlight-current
        check-strictly
        @check-change="checkChange"
        :props="defaultProps">
      </el-tree>
    </el-dialog>
  </div>
</template>

<script>
import { getSystemData } from '@/api/systemMange';
import { getMenuList, addMenuData, updateMenuData } from '@/api/menuMange';
export default {
  data () {
    return {
      innerVisible: false, // 上级部门 dialog
      title: '新增菜单',
      // 新增/编辑表单
      ruleForm: {
        companyId: '', // 系统ID
        menuLevel: 'M', // 菜单类型
        menuName: '', // 菜单名称
        menuParentId: '', // 父级菜单
        menuParentName: '', // 父级菜单名称
        menuPermissions: '', // 权限标识
        component: '', // 组件路径
        name: '', // 路由路径
        menuDesc: '', // 菜单描述
        sortNo: '', // 显示排序
        menuShow: true, // 菜单状态
        alive: 1,
        keepAlive: true,
        hidden: true,
        icon:'',//系统图标
      },
      rules: {
        companyId: [
          { required: true, message: '请选择系统', trigger: ['change', 'blur'] }
        ],
        menuParentId: [
          {required: true, message: '请选择父级菜单', trigger: ['blur', 'change']}
        ],
        menuLevel: [
          {required: true, message: '请选择菜单类型', trigger: 'change'}
        ],
        menuName: [
          {required: true, message: '请输入菜单名称', trigger: 'blur'}
        ],
        menuPermissions: [
          {required: true, message: '请输入权限标识', trigger: 'blur'}
        ],
      },
      tableData: [], // 菜单树形列表
      companyOptions: [],
      defaultProps: {
        children: 'children',
        label: 'menuName'
      },
      i: 0
    };
  },
  created() {
    if(JSON.parse(this.$route.query.item).menuName){
      this.title = '菜单编辑'
      this.ruleForm = JSON.parse(this.$route.query.item)
    }
    this.ruleForm.keepAlive == false ? this.ruleForm.alive = 0 : this.ruleForm.alive = 1
    this.getAllSystemInfo()
  },

  methods: {
    // 查询所有系统信息
    async getAllSystemInfo(){
      let searchSystemParams = {
        pageNo: 1,
        pageSize: 100,
        userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId,
        companyId: ''
      }
      const res = await getSystemData(searchSystemParams);
      if(res.code == 200){
        this.companyOptions = res.data.list
      }else{
        this.$message.error(res.msg)
      }
    },
    // 新增部门上级菜单聚焦判断是否选择了系统
    selectMenuItem(){
      if(!this.ruleForm.companyId){
        this.$message.error('请优先选择系统')
        return
      }
      this.getMenuTreeList();
      this.innerVisible = true
    },
    // 查询系统的所有菜单列表
    async getMenuTreeList() {
      this.loading = true
      const res = await getMenuList(this.ruleForm);
      if (res.code === '200') {
          this.tableData = res.data
      } else {
          this.$message.error(res.msg)
      }
      this.loading = false
    },
    // 新增/编辑部门选择上级部门
    checkChange(data, checked, node){
      this.i++;
      if(this.i % 2 === 0){
        if(checked){
          this.$refs.tree.setCheckedNodes([]);
          this.$refs.tree.setCheckedNodes([data]);
        }else{
          this.$refs.tree.setCheckedNodes([]);
        }
      }
      // 将获取的值赋值给输入框
      let res = this.$refs.tree.getCheckedNodes()
      res.forEach((item) => {
        this.ruleForm.menuParentName = data.menuName;
        this.ruleForm.menuParentId = data.menuId
      })
    },
    // 确定按钮点击事件
    changeOrAddMenu(formName){
      this.$refs[formName].validate((valid) => {
        if(valid){
          this.title == '新增菜单' ? this.confirmAddMenuItem() : this.confirmUpdateMenuItem()
        }else{
          return false
        }
      })
    },
    // 确定增加菜单
    async confirmAddMenuItem(){
      const res = await addMenuData(this.ruleForm);
      if(res.code === '200'){
        this.$message.success('新增成功')
        this.$router.back()
      }else{
        this.$message.error(res.msg)
      }
    },
    // 确定更新菜单
    async confirmUpdateMenuItem(){
      const res = await updateMenuData(this.ruleForm);
      if(res.code === '200'){
        this.$message.success('修改成功')
        this.$router.back()
      }else{
        this.$message.error(res.msg)
      }
    },
  }
}

</script>
<style scoped>
::v-deep .el-form{
  width: 50%;
  margin: 0 auto;
}
</style>
<style lang='scss' scoped>
.footer-btn{
  text-align: center;
  margin: 80px 0 10px;
}
</style>